import { BaseModel } from "sjs-base-model";

export default class ProvinciaModel extends BaseModel {
    public readonly code: string = "";
    public readonly name: string = "";

    constructor(data: Partial<ProvinciaModel>) {
        super();

        this.update(data);
    }
}
